interface SortControlsProps {
  value: string;
  onChange: (sort: string) => void;
}

const SortControls = ({ value, onChange }: SortControlsProps) => {
  return (
    <div className="flex items-center gap-2 sm:gap-3">
      <label className="text-xs sm:text-sm font-semibold text-gray-700 whitespace-nowrap">
        <i className="ri-sort-desc mr-1 sm:mr-2 text-teal-600"></i>
        Sort by:
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="flex-1 sm:flex-none px-3 sm:px-4 py-2 sm:py-2.5 bg-white border border-gray-300 rounded-lg text-xs sm:text-sm text-gray-900 focus:outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 transition-all cursor-pointer"
      >
        <option value="date">Date (Earliest First)</option>
        <option value="popular">Most Popular</option>
        <option value="price-low">Price: Low to High</option>
        <option value="price-high">Price: High to Low</option>
      </select>
    </div>
  );
};

export default SortControls;
